import { createPortal } from "react-dom";
import { Route, Router } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { useState, useEffect } from "react";
import sendRequest2 from "hooks/useAxios2";
import Select from "react-select";
import sendRequest from "hooks/useAxios";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import axios from "axios";
import toast from "react-hot-toast";

export default function UpdateOrderModal({
  selectedItem,
  updateSelectedItem,
  orderUpdater
}) {
  const [addModalOrder, setAddModalOrder] = useState({
    NameUser: "",
    rescipient_address: "",
    sendDate: "",
    rescipient_mobile: "",
    discount: "",
    price: "",
    order_code: "",
    OrderNumber: "",
    debtAmount: "",
    despription: "",
    addProduct: "",
    PriceSingleProduct: "",
    choseFile: "",
    selectedProducts: [],
    deleteProducts: [],
    user_muid: "",
    mobile: "",
    sendtm: ""
  });
  const [deletedProducts, setDeletedProducts] = useState([]);
  useEffect(() => {
    setAddModalOrder({
      ...selectedItem,
      deleteProducts: [],

      selectedProducts:
        addModalOrder.selectedProducts != []
          ? addModalOrder.selectedProducts
          : []
    });
  }, [selectedItem]);
  // timestamo
  const timestampToDate = time => {
    if (time != "") {
      const a = time * 1000;
      const date = new DateObject({ date: a, calendar: persian });
      return date.format();
    }
  };
  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          obj.id = arrayValue[index].id;
        } else {
          obj.title = arrayValue[index].label;
          obj.id = arrayValue[index].value;
          obj.main_price = arrayValue[index].price;
          obj.main_discount = arrayValue[index].discount;
          obj.url = arrayValue[index].choseFile;
          obj.itemcount = arrayValue[index].number;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;
        obj.value = arrayValue[index].id;
        obj.price = arrayValue[index].main_price;
        obj.discount = arrayValue[index].main_discount;
        obj.choseFile = arrayValue[index].description;
        obj.url = arrayValue[index].url;

        after.push(obj);
      }
    }

    return after;
  };
  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          // obj.id = arrayValue[index].id;
        } else {
          // obj.title = arrayValue[index].label;
          // obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = `${arrayValue[index].fname} ${arrayValue[index].lname}`;
        obj.value = arrayValue[index].id;
        obj.mobile = arrayValue[index].mobile;

        after.push(obj);
      }
    }

    return after;
  };
  const [tempValidateValues, setTempValidateValues] = useState({
    number: true,
    discount: true
  });
  const changeHandler = (value, type) => {
    setAddModalOrder(prev => {
      return { ...prev, [type]: value };
    });
  };
  const phoneNumberValidation = phone => {
    return /^09\d{9}$/.test(phone);
  };
  const checkNationalCode = national_code => {
    return /^[0-9]{10}$/.test(national_code);
  };
  // const [textItem, setTextItem] = useState([
  //   { title: "d1", number: "2", discount: 50000, totalPrice: 30000000 },
  //   { title: "d2", number: "4", discount: 100000, totalPrice: 7000000 },
  // ]);

  const [validateValues, setValidateValues] = useState({
    NameUser: true,
    address: true,
    phone: true,
    price: true,
    sendDate: true,
    OrderNumber: true,
    debtAmount: true,
    description: true,
    discount: true,
    PriceSingleProduct: true,
    title: true,
    addProduct: true,
    rescipient_mobile: true,
    rescipient_postalcode: true
  });

  const ValidationDetailsOrder = () => {
    let isValidate = true;
    if (tempValue.number > 0) {
      setTempValidateValues(prev => {
        return { ...prev, number: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, number: false };
      });
      isValidate = false;
    }
    if (tempValue.discount >= 0) {
      setTempValidateValues(prev => {
        return { ...prev, discount: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, discount: false };
      });
      isValidate = false;
    }
    return isValidate;
  };

  const ValidationOrder = () => {
    let isValidate = true;

    if (phoneNumberValidation(addModalOrder.rescipient_mobile)) {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: true };
      });
    } else if (addModalOrder.rescipient_mobile == "") {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, rescipient_mobile: false };
      });
      isValidate = false;
    }
    // validate postal-code
    if (checkNationalCode(addModalOrder.rescipient_postalcode)) {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: true };
      });
    } else if (addModalOrder.rescipient_postalcode == "") {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, rescipient_postalcode: false };
      });
      isValidate = false;
    }

    // if (addModalOrder.rescipient_address != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, address: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, address: false };
    //   });
    //   isValidate = false;
    // }
    // if (phoneNumberValidation(addModalOrder.phone)) {
    //   setValidateValues((prev) => {
    //     return { ...prev, phone: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, phone: false };
    //   });
    //   isValidate = false;
    // }
    // if (addModalOrder.userName != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, NameUser: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, NameUser: false };
    //   });
    //   isValidate = false;
    // }
    if (addModalOrder.sendtm != "") {
      setValidateValues(prev => {
        return { ...prev, sendDate: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, sendDate: false };
      });
      isValidate = false;
    }
    // --------------
    // if (addModalOrder.OrderNumber != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, OrderNumber: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, OrderNumber: false };
    //   });
    // }
    // if (addModalOrder.debtAmount) {
    //   setValidateValues((prev) => {
    //     return { ...prev, debtAmount: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, debtAmount: false };
    //   });
    // }
    // start--------------------------
    if (
      addModalOrder.selectedProducts.length > 0 ||
      addModalOrder.items.length > 0
    ) {
      setValidateValues(prev => {
        return { ...prev, addProduct: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, addProduct: false };
      });
      isValidate = false;
    }
    if (addModalOrder.despription != "") {
      setValidateValues(prev => {
        return { ...prev, despription: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, despription: false };
      });
      isValidate = false;
    }
    // end--------------------
    // if (addModalOrder.price != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, price: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, price: false };
    //   });
    // }
    // if (addModalOrder.PriceSingleProduct != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, PriceSingleProduct: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, PriceSingleProduct: false };
    //   });
    // }
    // if (addModalOrder.discount != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, discount: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, discount: false };
    //   });
    // }
    // if (addModalOrder.title != "") {
    //   setValidateValues((prev) => {
    //     return { ...prev, title: true };
    //   });
    // } else {
    //   setValidateValues((prev) => {
    //     return { ...prev, title: false };
    //   });
    // }
    return isValidate;
  };

  console.log("selectedItem", selectedItem);
  console.log("addModalOrder", addModalOrder);

  useEffect(() => {
    setAddModalOrder(addModalOrder);
  }, [addModalOrder]);
  const [userOptions, setUserOptions] = useState([
    { value: "0", label: "ali", phoneNumber: "0901111111" },
    { value: "1", label: "reza", phoneNumber: "0902111111" },
    { value: "2", label: "hosein", phoneNumber: "0903111111" }
  ]);
  const RemoveCounter = index => {
    let newArray = addModalOrder.selectedProducts.filter(
      (value, index2, array) => {
        if (index == index2) {
          return false;
        } else {
          return true;
        }
      }
    );
    setAddModalOrder(prev => {
      return { ...prev, selectedProducts: [...newArray] };
    });
  };
  const RemoveText = index => {
    let newArray = selectedItem.items.filter((value, index2, array) => {
      if (index == index2) {
        setDeletedProducts(prev => {
          return [...prev, value.id];
        });
        return false;
      } else {
        return true;
      }
    });
    updateSelectedItem(prev => {
      return { ...prev, items: [...newArray] };
    });
    // setTextItem([...newArray]);
  };
  // const RemoveText = (index) => {
  //   let newArray = selectedItem.items.filter((value, index2, array) => {
  //     if (index == index2) {

  //       return false;
  //     } else {
  //       return true;
  //     }
  //   });
  //   updateSelectedItem((prev) => {
  //     return { ...prev, items: [...newArray] };
  //   });
  //   // setTextItem([...newArray]);
  // };
  const [productList, setProductList] = useState([
    // { title: "divice 1", price: "100", id: 0 },
    // { title: "divice 2", price: "200", id: 1 },
    // { title: "divice 3", price: "300", id: 2 },
  ]);
  const [defaultProduct, setDefaultProduct] = useState([]);
  useEffect(() => {
    sendRequest("Find_products", {
      tbl_name: `left join,files,coverimg_fileid,id`
    }).then(data => {
      const lists = translateProductToReactSelect(data.data, false);
      setDefaultProduct(lists);
    });
  }, []);
  // const [defaultUser, setDefaultUser] = useState([]);
  // useEffect(() => {
  //   sendRequest("Find_users").then((data) => {
  //     const lists = translateUserToReactSelect(data.data, false);
  //     setDefaultUser(lists);
  //   });
  // }, []);
  const [tempValue, setTempValue] = useState({
    label: "",
    price: "",
    value: "",
    number: 0,
    discount: "",
    choseFile: ""
  });
  console.log("temp", tempValue);
  let formDataUpdateOrder = new FormData();
  const updateOrder = () => {
    for (let i = 0; i < addModalOrder.selectedProducts.length; i++) {
      formDataUpdateOrder.append(
        `order_items[${i}][productid]`,
        addModalOrder.selectedProducts[i].value
      );
      formDataUpdateOrder.append(
        `order_items[${i}][number]`,
        +addModalOrder.selectedProducts[i].number
      );
      formDataUpdateOrder.append(
        `order_items[${i}][discount]`,
        +addModalOrder.selectedProducts[i].discount
      );
      // }
    }
    formDataUpdateOrder.append("order_id", selectedItem.id);
    formDataUpdateOrder.append("type", "0");
    formDataUpdateOrder.append("order_type", "0");
    formDataUpdateOrder.append(
      "send_trackingcode",
      addModalOrder.send_trackingcode
    );
    formDataUpdateOrder.append(
      "deleted_order_items_ids",

      deletedProducts.toString()
    );
    formDataUpdateOrder.append("sendtm", addModalOrder.sendtm);
    formDataUpdateOrder.append("despription", addModalOrder.despription);
    formDataUpdateOrder.append(
      "rescipient_fname",
      addModalOrder.rescipient_fname ? addModalOrder.rescipient_fname : ""
    );
    formDataUpdateOrder.append(
      "rescipient_lname",
      addModalOrder.rescipient_lname ? addModalOrder.rescipient_lname : ""
    );
    formDataUpdateOrder.append(
      "rescipient_mobile",
      addModalOrder.rescipient_mobile ? addModalOrder.rescipient_mobile : ""
    );
    formDataUpdateOrder.append(
      "rescipient_address",
      addModalOrder.rescipient_address ? addModalOrder.rescipient_address : ""
    );
    formDataUpdateOrder.append(
      "rescipient_postalcode",
      addModalOrder.rescipient_postalcode
        ? addModalOrder.rescipient_postalcode
        : ""
    );

    formDataUpdateOrder.append("img", addModalOrder.choseFile);

    for (var [key, value] of formDataUpdateOrder.entries()) {
      console.log(key, value);
    }
    sendRequest2("editorder_new", formDataUpdateOrder).then(data => {
      console.log("data", data);
      if (data.data.status == 1) {
        toast.success("سفارش با موفقیت ویرایش شد.");
        // setUpdateProduct((prev) => !prev);
        document.querySelector("#UpdateOrderModal .btn-close").click();
        orderUpdater(prev => {
          return !prev;
        });
        setAddModalOrder(prev => {
          return { ...prev, selectedProducts: [] };
        });
      } else {
        toast.error("مشکلی در ویرایش سفارش پیش آمده است.");
      }
    });
  };
  const modalVar = (
    <div
      className="modal fade addOrder"
      id="UpdateOrderModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        {Object.keys(selectedItem).length && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              padding: "10px"
            }}
          >
            <div class="modal-header">
              <h5 class="modal-title"> ویرایش سفارشات</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <form action="#" data-parsley-validate noValidate>
                  {/* مشخصات کاربر */}
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        مشخصات کاربر :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row py-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex  align-items-baseline mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="name"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          نام کاربر:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          //  width: "75%"
                        }}
                      >
                        {`${selectedItem.user_muid.fname} ${selectedItem.user_muid.lname}`}
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex align-items-baseline  mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="phone"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          موبایل :
                        </label>
                      </div>
                      {/* phone number */}
                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "75%"
                        }}
                      >
                        {selectedItem.user_muid.mobile}
                      </div>
                    </div>
                    {/* address */}
                    {/* <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="labelAddress"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        <label
                          htmlFor="address"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          آدرس :
                        </label>
                      </div>

                      <div
                        className="inputAddress"
                        style={{
                          direction: "rtl",
                          //  width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          name="address"
                          id="address"
                          parsley-trigger="change"
                          className="form-control"
                          value={selectedItem.rescipient_address}
                          onChange={(e) => {
                            changeHandler(e.target.value, "rescipient_address");
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.address == ""
                                ? "visible"
                                : "hidden",
                          }}
                        >
                          لطفا آدرس را وارد کنید.
                        </p>
                      </div>
                    </div> */}
                  </div>
                  {/* مشخصات گیرنده */}
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        مشخصات گیرنده :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3 d-flex align-items-baseline"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    {/* نام گیرنده */}
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_fname"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          نام گیرنده:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_fname"
                          className="form-control"
                          id="rescipient_fname"
                          defaultValue={selectedItem.rescipient_fname}
                          value={addModalOrder.rescipient_fname}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_fname");
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_lname"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          فامیلی گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_lname"
                          className="form-control"
                          id="rescipient_lname"
                          defaultValue={selectedItem.rescipient_lname}
                          value={addModalOrder.rescipient_lname}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_lname");
                          }}
                        />
                      </div>
                    </div>
                    {/* موبایل گیرنده */}
                    <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_mobile"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          موبایل گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          //  width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_mobile"
                          className="form-control"
                          id="rescipient_mobile"
                          // defaultValue={selectedItem.rescipient_mobile}
                          value={addModalOrder.rescipient_mobile}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_mobile");
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            display:
                              validateValues.rescipient_mobile == false
                                ? "block"
                                : "none"
                          }}
                        >
                          شماره همراه وارد شده اشتباه است.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_mobile"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          کد پستی گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          //  width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_postalcode"
                          className="form-control"
                          id="rescipient_postalcode"
                          defaultValue={selectedItem.rescipient_postalcode}
                          value={addModalOrder.rescipient_postalcode}
                          onChange={e => {
                            changeHandler(
                              e.target.value,
                              "rescipient_postalcode"
                            );
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            display:
                              validateValues.rescipient_postalcode == false
                                ? "block"
                                : "none"
                          }}
                        >
                          کدپستی 10 رقمی گیرنده را صحیح وارد کنید
                        </p>
                      </div>
                    </div>
                    {/* ادرس */}
                    <div className=" col-12 d-flex my-3 container-responsive">
                      <div
                        className="labelReceptor"
                        style={{
                          // width: "17%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="address"
                          style={{
                            color: "#707070",
                            whiteSpace: "nowrap"
                          }}
                        >
                          آدرس گیرنده :
                        </label>
                      </div>

                      <div
                        className="inputReceptor"
                        style={{
                          direction: "rtl"
                          // width: "83%",
                        }}
                      >
                        <textarea
                          type="text"
                          required
                          className="form-control "
                          id="address"
                          name="address"
                          defaultValue={selectedItem.rescipient_address}
                          value={addModalOrder.rescipient_address}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_address");
                          }}
                        />

                        {/* <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.address == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا آدرس را وارد کنید .
                      </p> */}
                      </div>
                    </div>
                  </div>
                  {/* جزئیات سفارش */}
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        جزئیات سفارش :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3 "
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="DateSubmit"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          تاریخ ارسال:
                        </label>
                      </div>

                      <div
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                        className="input"
                      >
                        <DatePicker
                          calendar={persian}
                          locale={persian_fa}
                          inputClass={"date-picker-style form-control"}
                          calendarPosition="bottom-right"
                          value={addModalOrder.sendtm * 1000}
                          id="DateSubmit"
                          onChange={e => {
                            setAddModalOrder(prev => {
                              return { ...prev, sendtm: e.unix };
                            });
                          }}
                        />
                        {/* <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.sendDate == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا تاریخ ارسال را وارد کنید.
                        </p> */}
                      </div>
                    </div>

                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      {/* code order */}
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="OrderNumber"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          کد پیگیری :
                        </label>
                      </div>

                      <div
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                        className="input"
                      >
                        <input
                          type="text"
                          // required
                          className="form-control"
                          id="OrderNumber"
                          name="OrderNumber"
                          value={addModalOrder.send_trackingcode}
                          onChange={e => {
                            if (!isNaN(e.target.value))
                              changeHandler(
                                e.target.value,
                                "send_trackingcode"
                              );
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.OrderNumber == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا شماره سفارش را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive ">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="debtAmo"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مانده حساب :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                      >
                        <input
                          // type="text"
                          // required
                          className="form-control"
                          id="debtAmo"
                          name="debtAmount"
                          // value={addModalOrder.debtAmount}
                          // onChange={(e) => {
                          //   if (!isNaN(e.target.value))
                          //     changeHandler(e.target.value, "debtAmount");
                          // }}
                          value={addCommas(
                            selectedItem.total_amount -
                              selectedItem.total_discount
                          )}
                          readOnly
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.debtAmount == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا مانده حساب را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="totalPrice"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مبلغ کل:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          //  width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="price"
                          name="price"
                          value={addCommas(
                            +selectedItem.items?.reduce(
                              (total, currentValue) => {
                                return (
                                  total +
                                  currentValue.main_discount *
                                    currentValue.itemcount
                                );
                              },
                              0
                            ) +
                              addModalOrder.selectedProducts?.reduce(
                                (total, currentValue) => {
                                  return (
                                    total +
                                    currentValue.discount * currentValue.number
                                  );
                                },
                                0
                              )
                          )}
                          onChange={e => {
                            if (!isNaN(e.target.value))
                              changeHandler(e.target.value, "price");
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.price == "" ? "visible" : "hidden"
                          }}
                        >
                          لطفا مبلغ کل را وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* جزئیات محصول */}
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        جزئیات محصول :
                      </p>
                    </div>
                    <button
                      style={{
                        height: "30px",
                        marginTop: "30px",
                        marginRight: "5px",
                        backgroundColor: "white",
                        border: "none",
                        fontSize: "20px"
                      }}
                      type="button"
                      onClick={() => {
                        if (ValidationDetailsOrder()) {
                          setTempValue({
                            label: "",
                            price: "",
                            id: 0,
                            value: "",
                            number: 0,
                            discount: "",
                            choseFile: ""
                          });
                          // console.log("tempValue", tempValue);
                          setAddModalOrder(prev => {
                            return {
                              ...prev,

                              selectedProducts: [
                                ...addModalOrder.selectedProducts,
                                tempValue
                              ]
                            };
                          });
                        }
                      }}
                    >
                      <FcPlus></FcPlus>
                    </button>
                  </div>
                  <div
                    className="row pb-5"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="addProduct"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          انتخاب محصول :
                        </label>
                      </div>
                      <div
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                        className="input"
                      >
                        <Select
                          options={defaultProduct}
                          value={tempValue}
                          onChange={e => {
                            console.log("e", e);
                            setTempValue(
                              e

                              //  => {
                              // console.log(e);
                              // return {
                              // ...productList[e.value],
                              // number: 0,
                              // };
                              // }
                            );
                          }}
                        ></Select>

                        {/* <select
                          id="addProduct"
                          // options={defaultProduct}
                          value={tempValue.id}
                          onChange={(e) => {
                            setTempValue(() => {
                              return {
                                ...productList[e.target.value],
                                number: 0,
                              };
                            });
                          }}
                          className="form-control form-select"
                        >
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              visibility:
                                validateValues.addProduct == ""
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            لطفا نام محصول را وارد کنید.
                          </p>

                          {productList.map((value, index) => {
                            return (
                              <option value={value.id}>{value.title}</option>
                            );
                          })}
                        </select> */}
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        style={{
                          //  width: "35%",
                          textAlign: "right"
                        }}
                        className="label"
                      >
                        <label
                          htmlFor="addProduct"
                          style={{
                            color: "#707070",
                            whiteSpace: "nowrap",
                            marginTop: "5px"
                          }}
                        >
                          قیمت محصول :
                        </label>
                      </div>
                      <div
                        className="input"
                        style={{
                          direction: "rtl",
                          width: "60%",
                          marginTop: "0",
                          paddingTop: "0",
                          marginRight: "10px"
                        }}
                      >
                        <p style={{ color: "red", margin: "0", padding: "0" }}>
                          {addCommas(tempValue.price)} تومان
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="number"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          تعداد :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                      >
                        <input
                          type="text"
                          name="number"
                          required
                          className="form-control"
                          id="number"
                          value={tempValue.number}
                          onChange={e => {
                            setTempValue(prev => {
                              return {
                                ...prev,
                                number: e.target.value
                              };
                            });
                          }}
                        />

                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.number
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا تعداد را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="Discount"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          قیمت بعد تخفیف :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                      >
                        <input
                          type="text"
                          name="Discount"
                          required
                          className="form-control"
                          id="Discount"
                          value={addCommas(tempValue.discount)} //{addModalOrder.Discount}
                          onChange={e => {
                            setTempValue(prev => {
                              return {
                                ...prev,
                                discount: removeCommas(e.target.value)
                              };
                            });
                          }}
                        />

                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.discount
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا مبلغ تخفیف را وارد کنید.
                        </p>
                      </div>
                    </div>
                    {/* <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        <label
                          htmlFor="choseFile"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          انتخاب فایل :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl",
                          //  width: "75%"
                        }}
                      >
                        <div className="mb-3">
                          <input
                            className="form-control"
                            type="file"
                            id="choseFile"
                            // value={tempValue.choseFile.value}
                            // onChange={(e) => {
                            //   setTempValue((prev) => {
                            //     return { ...prev, choseFile: e.target };
                            //   });
                            // }}
                          />
                        </div>
                      </div>
                    </div> */}
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        visibility:
                          validateValues.addProduct == "" ? "visible" : "hidden"
                      }}
                    >
                      لیست محصولات سفارش نباید خالی باشد.
                    </p>
                    {selectedItem.items.map((value, index) => {
                      console.log("select", value);
                      return (
                        <div
                          className="d-flex pt-3 mt-4"
                          style={{
                            // borderBottom: "1px solid #dee2e6",
                            marginTop: "2px"
                          }}
                        >
                          <div className="">
                            <img
                              src={`http://grc.tatdemo.ir/${value.url}`}
                              style={{ width: "50px", height: "50px" }}
                            />
                          </div>
                          <div className="">
                            <p
                              style={{
                                fontSize: "13px",
                                // color: "red",
                                marginTop: "5px"
                              }}
                            >
                              شما محصول:
                              <span
                                style={{
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                  color: "red"
                                }}
                              >
                                {value.title}
                              </span>
                              به تعداد:
                              <span
                                style={{
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                  color: "red"
                                }}
                              >
                                {value.itemcount}
                                {/* {value.number} */}
                              </span>
                              با قیمت:
                              <span
                                style={{
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                  color: "red"
                                }}
                              >
                                {addCommas(value.main_discount)}
                                {/* {value.discount.toLocaleString()} */}
                                تومان
                              </span>
                              و به مجموع قیمت :
                              <span
                                style={{
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                  color: "red"
                                }}
                              >
                                {addCommas(
                                  value.main_discount * value.itemcount
                                )}
                                {/* {value.totalPrice.toLocaleString()} */}
                              </span>
                              تومان سفارش دادید.
                            </p>
                          </div>
                          <div
                            className=""
                            style={{ width: "5px", textAlign: "left" }}
                          >
                            <button
                              type="button"
                              style={{
                                border: "none",
                                backgroundColor: "#f9f7f8",
                                backgroundColor: "white",
                                fontSize: "20px"
                              }}
                              onClick={() => {
                                RemoveText(index);
                              }}
                            >
                              <HiMinusCircle
                                style={{ color: "#35b8e0" }}
                              ></HiMinusCircle>
                            </button>
                          </div>
                          <div
                            style={{
                              borderBottom: "1px solid #dee2e6",
                              height: "3px",
                              marginRight: "5px"
                            }}
                          ></div>
                        </div>
                      );
                    })}
                    {addModalOrder.selectedProducts?.map((value, index) => {
                      console.log("ppp", value);
                      return (
                        //   <div
                        //     className="d-flex pt-3 mt-4"
                        //     style={{
                        //       // borderBottom: "1px solid #dee2e6", */}
                        //       marginTop: "2px"
                        //     }}
                        //   >
                        //     <div className="">
                        //       <img
                        //         src={`http://grc.tatdemo.ir/${value.url}`}
                        //         // src={
                        //         //   value.choseFile.files == undefined
                        //         //     ? ""
                        //         //     : URL.createObjectURL(
                        //         //         value.choseFile.files[0]
                        //         //       )
                        //         // }
                        //         style={{ width: "50px", height: "50px" }}
                        //       />
                        //     </div>
                        //     <div className="">
                        //       <p
                        //         style={{
                        //           fontSize: "13px",

                        //           marginTop: "5px"
                        //         }}
                        //       >
                        //         شما محصول:
                        //         <span
                        //           style={{
                        //             marginRight: "5px",
                        //             marginLeft: "5px",
                        //             color: "red"
                        //           }}
                        //         >
                        //           {value.label}
                        //         </span>
                        //         به تعداد:
                        //         <span
                        //           style={{
                        //             marginRight: "5px",
                        //             marginLeft: "5px",
                        //             color: "red"
                        //           }}
                        //         >
                        //           {value.number}
                        //         </span>
                        //         با قیمت :
                        //         <span
                        //           style={{
                        //             marginRight: "5px",
                        //             marginLeft: "5px",
                        //             color: "red"
                        //           }}
                        //         >
                        //           {addCommas(value.discount)}
                        //           تومان
                        //         </span>
                        //         و به مجموع قیمت :
                        //         <span
                        //           style={{
                        //             marginRight: "5px",
                        //             marginLeft: "5px"
                        //           }}
                        //         >
                        //           {addCommas(value.discount * value.number)}
                        //         </span>
                        //         تومان سفارش دادید.
                        //       </p>
                        //     </div>
                        //     <div
                        //       className=""
                        //       style={{ width: "5px", textAlign: "left" }}
                        //     >
                        //       <button
                        //         type="button"
                        //         style={{
                        //           border: "none",
                        //           backgroundColor: "#f9f7f8",
                        //           backgroundColor: "white",
                        //           fontSize: "20px"
                        //         }}
                        //         onClick={() => {
                        //           RemoveCounter(index);
                        //         }}
                        //       >
                        //         <HiMinusCircle
                        //           style={{ color: "#35b8e0" }}
                        //         ></HiMinusCircle>
                        //       </button>
                        //     </div>
                        //     <div
                        //       style={{
                        //         borderBottom: "1px solid #dee2e6",
                        //         height: "3px",
                        //         marginRight: "5px"
                        //       }}
                        //     ></div>
                        //   </div>
                        <div className="d-flex flex-row flex-wrap mt-4 shadow px-0 mx-2">
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              عکس
                            </div>
                            <div className="text-center p-1">
                              <img
                                src={`http://grc.tatdemo.ir/${value.url}`}
                                style={{ width: "30px", height: "30px" }}
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              نام محصول
                            </div>
                            <div className="text-center fs-11 pt-2">
                              {value.label}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              تعداد
                            </div>
                            <div className="text-center fs-11 pt-2">
                              {value.number}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              قیمت هر محصول
                            </div>
                            <div className="text-center fs-11 pt-2">
                              {value.price}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              تخفیف هر محصول
                            </div>
                            <div className="text-center fs-11 pt-2">
                              {value.discount}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              مبلغ نهایی
                            </div>
                            <div className="text-center fs-11 pt-2">
                              {addCommas(
                                (value.price - value.discount) * value.number
                              )}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <div className="text-center bg-blue text-white fs-11 p-1">
                              حذف سفارش
                            </div>
                            <div className="text-center fs-11 p-1">
                              <button
                                type="button"
                                style={{
                                  border: "none",
                                  backgroundColor: "#f9f7f8",
                                  backgroundColor: "white",
                                  fontSize: "20px"
                                }}
                                onClick={() => {
                                  RemoveCounter(index);
                                }}
                              >
                                <HiMinusCircle
                                  style={{ color: "#35b8e0" }}
                                ></HiMinusCircle>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        توضیحات :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className=" col-12 col-lg-12 d-flex container-responsive mt-2">
                      <div
                        className="labelDesc"
                        style={{
                          // width: "20%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="desc2"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          توضیحات :
                        </label>
                      </div>
                      <div
                        className="inputDesc"
                        style={{
                          direction: "rtl"
                          // width: "100%",
                        }}
                      >
                        <textarea
                          required
                          className="form-control"
                          id="desc2"
                          name="description"
                          defaultValue={selectedItem.despription}
                          value={addModalOrder.despription}
                          onChange={e => {
                            changeHandler(e.target.value, "despription");
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.description == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا توضیحات را وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  console.log(validateValues);
                  if (ValidationOrder()) {
                    updateOrder();
                  }
                  console.log(ValidationOrder());
                }}
              >
                ویرایش
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(modalVar, document.querySelector("#modals"));
}
